//  一楼
export const groundFloor = {
    boothList:[
        {
            name: '1号展厅',
            position: [110.378616,20.015886],
            // id: '371',
            id: '2191',
        },
        {
            name: '2号展厅',
            position: [110.378503,20.01543],
            // id: '372',
            id: '2192',
        },
        {
            name: '13号展厅',
            position: [110.378621,20.015153],
            // id: '383',
            id: '2203',
        },
        {
            name: '12号展厅',
            position: [110.378834,20.014831],
            // id: '382',
            id: '2202',
        },
        {
            name: '11号展厅',
            position: [110.379096,20.01465],
            // id: '381',
            id: '2201',
        },
        {
            name: '10号展厅',
            position: [110.379084,20.014927],
            // id: '380',
            id: '2200',
        },
        // {
        //     name: `"华光礁1号"沉船保护实验室`,
        //     position: [110.379419,20.014761],
        // },
        // {
        //     name: `艺术馆接待室`,
        //     position: [110.379649,20.015048],
        // },
        // {
        //     name: `历史馆接待室`,
        //     position: [110.379279,20.015368],
        // },
        // {
        //     name: `海梨阁`,
        //     position: [110.379434,20.015436],
        // },
        // {
        //     name: `多功能展示厅`,
        //     position: [110.379395,20.015172],
        // },
        {
            name: `历史馆`,
            position: [110.379103,20.015629],
        },
        {
            name: '特展馆',
            position: [110.37941,20.015846],
        },
        // {
        //     name: '医务室',
        //     icon: 'iconjiuzhibao',
        //     activeClass: 'iconjiuzhibao-active',
        //     // position: [110.37943,20.01502],
        //     position: [110.379408,20.015044],
        // },
    ],
    list:[
        {
            name: '电梯',
            active: 0,
            icon: 'icondianti',
            activeClass: 'icondianti-active',
            list: [
                [110.378899,20.015345],
                [110.378899,20.015155],
            ],
        },
        {
            name: '卫生间',
            active: 1,
            icon: 'iconweishengjian1',
            activeClass: 'iconicon-test1-active icondianti-active',
            list: [
                [110.379446,20.015253],
                [110.379424,20.014902],
                [110.378804,20.0154],// 2号厅右侧
                [110.379179,20.015389],//   历史馆边上
            ],
        },
        {
            name: '自助充电设备',
            active: 2,
            icon: 'iconbanhalf32',
            activeClass: 'icondianti-active',
            list: [
                [110.378989,20.015187],
            ],
        },
        {
            name: '志愿者服务站',
            active: 3,
            icon: 'iconganxingqu',
            activeClass: 'icondianti-active',
            list: [
                [110.378984,20.015402],
            ],
        },
        {
            name: '楼梯',
            active: 4,
            icon: 'iconhuabanfuben1',
            activeClass: 'iconicon-test1-active icondianti-active',
            list: [
                [110.379265,20.014878],//   10号右边
                [110.378978,20.014878],//   10号左边
                [110.378787,20.015003],//   13号边楼梯
                [110.379103,20.015505],//   正中楼梯
                [110.378828,20.015718],//   1号厅后右侧
                [110.378412,20.015736],//   1号厅后左侧
                [110.378436,20.015499],//   2号厅前左侧
                [110.378838,20.015505],//   2号厅前右侧
                [110.379312,20.01515],//    黄色大块右后
                [110.379426,20.015542],//   特展馆后面
            ],
        },
        {
            name: '无障碍卫生间',
            active: 5,
            icon: 'iconwuzhangai',
            activeClass: 'iconwuzhangai-active',
            list: [
                [110.379446,20.015253],
                [110.379179,20.015389],//   历史馆边上
            ],
        },
        {
            name: '观众休息区域',
            active: 6,
            icon: 'iconxiuxiqu',
            activeClass: 'icondianti-active',
            list: [
                [110.378727,20.015613],
                [110.378976,20.015244],
            ],
        },
        {
            name: '游客中心',
            active: 7,
            icon: 'iconyiersanjiyoukezhongxin',
            activeClass: 'iconyiersanjiyoukezhongxin-active',
            list: [
                [110.379186,20.015199],
                [110.379266,20.015799],
            ],
        },
        {
            name: '参观入口',
            active: 8,
            icon: 'iconchurukou',
            activeClass: 'iconicon-test1-active icondianti-active',
            list: [
                [110.3792,20.015884],
            ],
        },
        {
            name: '参观出口',
            active: 9,
            icon: 'iconchurukou',
            activeClass: 'iconicon-test1-active icondianti-active',
            list: [
                [110.37893,20.015884],
            ],
        },
        {
            name: '擦鞋机',
            active: 10,
            icon: 'iconpixie',
            activeClass: 'icondianti-active',
            list: [
                [110.379331,20.014872],
            ],
        },




        {
            name: '饮用水',
            active:11,
            icon: 'iconyinshuichu',
            activeClass: 'car-active',
            list: [
                [110.379222,20.015234],
            ],
        },
        {
            name: '领票处',
            active: 12,
            icon: 'iconhuaban-',
            activeClass: 'icondianti-active',
            list: [
                [110.379275,20.015875],
            ],
        },
        {
            name: '安检处',
            active: 13,
            icon: 'icon-control-',
            activeClass: 'icondianti-active',
            list: [
                [110.379213,20.015865],
            ],
        },


        // {
        //     name: '咖啡',
        //     active: 4,
        //     icon: 'iconicon-test1',
        //     activeClass: 'iconicon-test1-active icondianti-active',
        //     list: [
        //         [110.378816,20.015576],
        //     ],
        // },

        //  可能是外层的
        {
            name: '停车场',
            active: 14,
            icon: 'icontingchechang',
            activeClass: 'car-active',
            list: [
                [110.3789,20.01601],//  北
                [110.379895,20.014919],//   东侧
                [110.378097,20.015659],//   西侧
                // [110.379393,20.014673],//   南
                [110.37919,20.014475]
            ],
        },

    ]
}

//  二楼
export const secondFloor = {
    boothList:[
        {
            name: '5号展厅',
            position: [110.378596,20.015925],
            // id: '375',
            id: '2195',
        },
        {
            name: '4号展厅',
            position: [110.378596,20.015686],
            // id: '374',
            id: '2194',
        },
        {
            name: '3号展厅',
            position: [110.378442,20.015417],
            // id: '373',
            id: '2193',
        },
        {
            name: '16号展厅',
            position: [110.378649,20.015167],
            // id: '386',
            id: '2206',
        },
        {
            name: '15号展厅',
            position: [110.379099,20.014597],
            // id: '385',
            id: '2205',
        },
        {
            name: '14号展厅',
            position: [110.379462,20.014923],
            // id: '384',
            id: '2204',
        },
        // {
        //     name: '图书馆',
        //     position: [110.379435,20.015793],
        // },
        // {
        //     name: '办公区',
        //     position: [110.379498,20.015397],
        // },
        {
            name: '历史馆',
            position: [110.379107,20.015706],
        },
        {
            name: `艺术馆`,
            position: [110.379105,20.014864],
        },
    ],
    list:[
        {
            name: '母婴室',
            active: 0,
            icon: 'iconmuying',
            activeClass: 'iconchongwuburu-active icondianti-active',
            list: [
                [110.379025,20.01542],
            ],
        },
        {
            name: '电梯',
            active: 1,
            icon: 'icondianti',
            activeClass: 'icondianti-active',
            list: [
                [110.378971,20.015412],
                [110.378935,20.015223],
            ],
        },
        {
            name: '卫生间',
            active: 2,
            icon: 'iconweishengjian1',
            activeClass: 'iconicon-test1-active icondianti-active',
            list: [
                [110.378825,20.015405],
                [110.378869,20.014638],
                [110.379476,20.015264],
                [110.379326,20.015408],
            ],
        },
        {
            name: '自助充电设备',
            active: 3,
            icon: 'iconbanhalf32',
            activeClass: 'icondianti-active',
            list: [
                [110.379327,20.014786],
            ],
        },
        {
            name: '自助饮水设备',
            active: 4,
            icon: 'iconyinshuichu',
            activeClass: 'car-active',
            list: [
                [110.379219,20.015384],
                [110.37908,20.014726],
            ],
        },
        {
            name: '楼梯',
            active: 5,
            icon: 'iconhuabanfuben1',
            activeClass: 'iconicon-test1-active icondianti-active',
            list: [
                [110.378565,20.015784],
                [110.378794,20.015784],
                [110.378554,20.015537],
                [110.378791,20.015537],
                [110.378769,20.015018],// 16
                [110.378989,20.01508],
                [110.379244,20.01508],
                [110.379328,20.015198],
                [110.379231,20.015432],
                [110.379466,20.01559],
            ],
        },
        {
            name: '无障碍卫生间',
            active: 6,
            icon: 'iconwuzhangai',
            activeClass: 'iconwuzhangai-active',
            list: [
                [110.378869,20.014638],
                [110.379476,20.015264],
                [110.379234,20.015393],
            ],
        },
        {
            name: '观众休息区域',
            active: 7,
            icon: 'iconxiuxiqu',
            activeClass: 'icondianti-active',
            list: [
                [110.379327,20.015024],
                [110.37891,20.015653],
            ],
        },
        {
            name: '擦鞋机',
            active: 8,
            icon: 'iconpixie',
            activeClass: 'icondianti-active',
            list: [
                [110.379327,20.01487],
            ],
        },
    ]
}

// 三楼
export const thirdFloor = {
    boothList:[
        {
            name: '8号展厅',
            position: [110.378595,20.015934],
            // id: '378',
            id: '2198',
        },
        {
            name: '7号展厅',
            position: [110.378595,20.015677],
            // id: '377',
            id: '2197',
        },
        {
            name: '6号展厅',
            position: [110.3785,20.015468],
            // id: '376',
            id: '2196',
        },
        {
            name: '19号展厅',
            position: [110.37864,20.015183],
            // id: '390',
            id: '2209',
        },
        {
            name: '18号展厅',
            position: [110.379078,20.014633],
            // id: '389',
            id: '2208',
        },
        {
            name: '17号展厅',
            position: [110.379462,20.014923],
            // id: '387',
            id: '2207',
        },
        {
            name: '9号展厅',
            position: [110.379435,20.015793],
            // id: '379',
            id: '2199',
        },
        // {
        //     name: '办公区',
        //     position: [110.379498,20.015397],
        // },
        // {
        //     name: '望江台',
        //     position: [110.379655,20.015041],
        // },
        {
            name: '历史馆',
            position: [110.379107,20.015706],
        },
        {
            name: `艺术馆`,
            position: [110.379105,20.014864],
        },
    ],
    list:[
        {
            name: '母婴室',
            active: 0,
            icon: 'iconmuying',
            activeClass: 'iconchongwuburu-active icondianti-active',
            list: [
                [110.378917,20.015415],
            ],
        },
        {
            name: '电梯',
            active: 1,
            icon: 'icondianti',
            activeClass: 'icondianti-active',
            list: [
                [110.378971,20.015412],
                [110.378935,20.015223],
            ],
        },
        {
            name: '卫生间',
            active: 2,
            icon: 'iconweishengjian1',
            activeClass: 'iconicon-test1-active icondianti-active',
            list: [
                [110.378825,20.015405],
                [110.378869,20.014638],
                [110.379476,20.015264],
                [110.379234,20.015393],
            ],
        },
        {
            name: '自助充电设备',
            active: 3,
            icon: 'iconbanhalf32',
            activeClass: 'icondianti-active',
            list: [
                [110.379327,20.014786],
            ],
        },
        {
            name: '自助饮水设备',
            active: 4,
            icon: 'iconyinshuichu',
            activeClass: 'car-active',
            list: [
                [110.379219,20.015384],
                [110.37908,20.014726],
            ],
        },
        {
            name: '无障碍卫生间',
            active: 5,
            icon: 'iconwuzhangai',
            activeClass: 'iconwuzhangai-active',
            list: [
                [110.378869,20.014638],
                [110.379476,20.015264],
                [110.379234,20.015393],
            ],
        },
        {
            name: '观众休息区域',
            active: 6,
            icon: 'iconxiuxiqu',
            activeClass: 'icondianti-active',
            list: [
                [110.379327,20.015024],
            ],
        },
        {
            name: '擦鞋机',
            active: 7,
            icon: 'iconpixie',
            activeClass: 'icondianti-active',
            list: [
                [110.379327,20.01487],
            ],
        },
        {
            name: '下楼梯',
            active: 8,
            icon: 'iconxialou',
            activeClass: 'iconicon-test1-active icondianti-active',
            list: [
                [110.378565,20.015784],
                [110.378794,20.015784],
                [110.378554,20.015537],
                [110.378791,20.015537],
                [110.378769,20.015018],// 16
                [110.378968,20.014829],
                [110.379313,20.015093],
                [110.379244,20.014817],
                [110.379231,20.015432],
                [110.379466,20.01559],
            ],
        },
        // {
        //     name: '停车场',
        //     active: 0,
        //     icon: 'icontingchechang',
        //     activeClass: 'car-active',
        //     list: [
        //         [110.378692,20.015774],
        //         [110.379378,20.01532],
        //     ],
        // },
        // {
        //     name: '游客中心',
        //     active: 1,
        //     icon: 'iconyiersanjiyoukezhongxin',
        //     activeClass: 'iconyiersanjiyoukezhongxin-active',
        //     list: [
        //         [110.378981,20.015124],
        //         [110.379614,20.015053],
        //     ],
        // },
        // {
        //     name: '电梯',
        //     active: 2,
        //     icon: 'icondianti',
        //     activeClass: 'icondianti-active',
        //     list: [
        //         [110.378981,20.015124],
        //         [110.379614,20.015053],
        //     ],
        // },
        // {
        //     name: '讲解服务',
        //     active: 3,
        //     icon: 'iconziyuan1',
        //     activeClass: 'iconziyuan1-active icondianti-active',
        //     list: [
        //         [110.378981,20.015124],
        //         [110.379614,20.015053],
        //     ],
        // },
        // {
        //     name: '咖啡',
        //     active: 4,
        //     icon: 'iconicon-test1',
        //     activeClass: 'iconicon-test1-active icondianti-active',
        //     list: [
        //         [110.378981,20.015124],
        //         [110.379614,20.015053],
        //     ],
        // },
        // {
        //     name: '行李寄存',
        //     active: 5,
        //     icon: 'iconhanglijicun',
        //     activeClass: 'iconhanglijicun-active icondianti-active',
        //     list: [
        //         [110.378981,20.015124],
        //         [110.379614,20.015053],
        //     ],
        // },
        // {
        //     name: '母婴室',
        //     active: 6,
        //     icon: 'iconchongwuburu',
        //     activeClass: 'iconchongwuburu-active icondianti-active',
        //     list: [
        //         [110.378981,20.015124],
        //         [110.379614,20.015053],
        //     ],
        // },
        // {
        //     name: '医务室',
        //     active: 7,
        //     icon: 'iconyiliao06',
        //     activeClass: 'iconyiliao06-active',
        //     list: [
        //         [110.378981,20.015124],
        //         [110.379614,20.015053],
        //     ],
        // },
    ]
}



